import { MdOutlineDashboardCustomize } from "react-icons/md";
import { AiOutlineAccountBook, AiOutlineSearch } from "react-icons/ai";

export const ManagementMenu = [
  {
    name: "داشبورد",
    path: "/dashboard/management",
    icon: <MdOutlineDashboardCustomize />,
    type: "menu",
    child: ["/dashboard/management"],
  },

  {
    name: "صورت جلسه",
    path: "/dashboard/management/Meetingsummary",
    icon: <AiOutlineSearch />,
    type: "menu",
    child: ["/dashboard/management/Meetingsummary"],
  },
  {
    name: "تیکت",
    path: "/dashboard/management/tickets",
    icon: <AiOutlineSearch />,
    type: "menu",
    child: [
      "/dashboard/management/tickets/:id",
      "/dashboard/management/tickets/AddTicket",
      "/dashboard/management/tickets/ticketsList",
      "/dashboard/management/tickets",
    ],
  },
  {
    name: "حضور و غیاب",
    path: "/dashboard/management/RollCall",
    icon: <AiOutlineSearch />,
    type: "menu",
    child: ["/dashboard/management/RollCall"],
  },
  {
    name: "تارگت",
    path: "/dashboard/management/Targeting",
    icon: <AiOutlineSearch />,
    type: "menu",
    child: [
      "/dashboard/management/Targeting",
      "/dashboard/management/Targeting/SetHollTarget",
      "/dashboard/management/Targeting/SetPersonTarget",
    ],
  },
  {
    name: "مدیریت پنل های پیامکی",
    path: "/dashboard/management/manaegmentSms",
    icon: <AiOutlineSearch />,
    type: "menu",
    child: ["/dashboard/management/manaegmentSms"],
  },
  {
    name: "تعریف همکار",
    path: "/dashboard/management/accessLevel",
    icon: <AiOutlineAccountBook />,
    type: "menu",
    child: ["/dashboard/management/accessLevel"],
  },
];
